export default __webpack_public_path__ + "static/test_3_1_ru-311f87b4ce8830872b445bd2cec203f4.png";